import { apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';
import type { ContextoAtivoRef, ContextosResponse } from '@/types/contextoAcesso/types';

const extrairErro = async (response: Response, padrao: string): Promise<never> => {
  const corpo = await response.json().catch(() => ({ error: padrao }));
  const erro = corpo as { error?: string | { message?: string }; message?: string };
  const mensagem =
    (typeof erro.error === 'object' ? erro.error?.message : erro.error) || erro.message || padrao;
  throw new Error(mensagem);
};

export const contextoAcessoService = {
  listar: async (): Promise<ContextosResponse> => {
    const response = await apiGet('/me/contextos');
    if (!response.ok) {
      return extrairErro(response, 'Erro ao carregar seus contextos');
    }
    const raw = await response.json();
    return (raw as { data?: ContextosResponse }).data ?? (raw as ContextosResponse);
  },

  /**
   * Sai do teto da sessão de portal. O token novo vem por cookie httpOnly, então
   * não há nada a guardar aqui — o que muda é o que a próxima requisição alcança.
   */
  promover: async (): Promise<void> => {
    const response = await apiPost('/me/sessao/plataforma', {});
    if (!response.ok) {
      await extrairErro(response, 'Não foi possível abrir a plataforma');
    }
  },

  trocar: async (contexto: ContextoAtivoRef): Promise<ContextoAtivoRef> => {
    const response = await apiPatch('/me/contexto', contexto);
    if (!response.ok) {
      return extrairErro(response, 'Erro ao trocar de contexto');
    }
    return contexto;
  },
};
